var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImgHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    viewBox: "0 0 288 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1418_15090)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 104,
    fill: "#F7F7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_1418_15090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.769 100.341L198.637 160.413C199.194 163.233 197.357 165.974 194.537 166.531L107.349 183.756C104.529 184.313 101.788 182.477 101.231 179.657L89.3628 119.586C88.8056 116.766 90.6423 114.025 93.4621 113.468L180.651 96.2422C183.471 95.685 186.211 97.5215 186.769 100.341Z",
    fill: "url(#paint0_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.537 166.532L107.349 183.756C104.529 184.314 101.789 182.477 101.23 179.657L100.448 175.698C101.305 175.966 102.24 176.031 103.184 175.845L186.768 100.341L198.638 160.413C199.193 163.233 197.357 165.973 194.537 166.532Z",
    fill: "url(#paint1_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.81 112.49V173.722C194.81 176.597 192.477 178.93 189.602 178.93H100.729C97.8542 178.93 95.5212 176.597 95.5212 173.722V112.49C95.5212 109.615 97.8542 107.282 100.729 107.282H189.602C192.477 107.282 194.81 109.615 194.81 112.49Z",
    fill: "url(#paint2_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.596 178.93H100.729C97.8527 178.93 95.5212 176.598 95.5212 173.722V112.49C95.5212 109.614 97.8529 107.282 100.729 107.282H189.602C192.479 107.282 194.81 109.614 194.81 112.49V154.079C194.81 154.876 194.496 155.641 193.937 156.208L173.624 176.825C172.297 178.172 170.486 178.93 168.596 178.93Z",
    fill: "url(#paint3_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.259 117.145V162.987C183.792 166.507 179.686 170.672 176.918 173.482H107.488C105.05 173.482 103.072 171.504 103.072 169.066V117.145C103.072 114.708 105.05 112.729 107.488 112.729H182.843C185.281 112.729 187.259 114.708 187.259 117.145Z",
    fill: "url(#paint4_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.81 169.557V173.723C194.81 176.597 192.477 178.93 189.602 178.93H100.729C97.8542 178.93 95.5212 176.597 95.5212 173.723V169.557H194.81Z",
    fill: "url(#paint5_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.098 169.536C103.112 169.666 103.132 169.793 103.157 169.919C103.161 169.942 103.166 169.965 103.171 169.988C103.197 170.112 103.228 170.234 103.264 170.354C103.271 170.375 103.278 170.395 103.285 170.416C103.324 170.538 103.367 170.658 103.416 170.776C103.421 170.786 103.426 170.796 103.43 170.807C103.479 170.919 103.532 171.029 103.589 171.136C103.597 171.152 103.605 171.168 103.614 171.184C103.672 171.291 103.736 171.394 103.802 171.495C103.817 171.518 103.832 171.54 103.848 171.563C103.914 171.659 103.984 171.753 104.058 171.843C104.076 171.866 104.095 171.888 104.114 171.911C104.189 172 104.268 172.088 104.35 172.171C104.368 172.188 104.386 172.205 104.403 172.222C104.481 172.298 104.561 172.372 104.645 172.442C104.661 172.455 104.676 172.469 104.692 172.483C105.454 173.106 106.427 173.481 107.487 173.481H176.917C179.083 171.282 182.068 168.254 184.926 165.353L161.467 143.832C159.654 142.169 156.87 142.169 155.056 143.832L144.647 153.381L128.281 137.025C126.342 134.703 122.713 134.764 120.865 137.21L103.072 160.755V169.066C103.072 169.206 103.08 169.343 103.093 169.48C103.095 169.499 103.096 169.518 103.098 169.536Z",
    fill: "url(#paint6_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.928 165.355C182.074 168.25 179.095 171.273 176.93 173.47L155.817 173.452L122.801 173.425L142.286 155.548L155.056 143.833C156.87 142.17 159.654 142.17 161.467 143.833L184.928 165.355Z",
    fill: "url(#paint7_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.467 143.832C159.654 142.169 156.87 142.169 155.056 143.832L142.286 155.547L155.817 173.451L176.931 173.469C179.095 171.272 182.074 168.249 184.928 165.354L161.467 143.832Z",
    fill: "url(#paint8_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.704 147.722C164.9 148.374 163.634 148.223 163.04 147.265L163.038 147.262C162.335 146.123 160.68 146.123 159.977 147.262V147.265C159.275 148.404 157.617 148.404 156.914 147.265V147.262C156.564 146.691 155.973 146.408 155.383 146.408C154.792 146.408 154.201 146.691 153.851 147.262C153.213 148.297 151.788 148.391 151.009 147.547L155.057 143.834C156.869 142.169 159.654 142.169 161.466 143.834L165.704 147.722Z",
    fill: "url(#paint9_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.704 147.722C164.9 148.374 163.634 148.223 163.04 147.265L163.038 147.262C162.335 146.123 160.68 146.123 159.977 147.262V147.265C159.275 148.404 157.617 148.404 156.914 147.265V147.262C156.564 146.691 155.973 146.408 155.383 146.408C154.792 146.408 154.201 146.691 153.851 147.262C153.213 148.297 151.788 148.391 151.009 147.547L155.057 143.834C156.869 142.169 159.654 142.169 161.466 143.834L165.704 147.722Z",
    fill: "url(#paint10_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.136 143.391C124.106 143.391 124.076 143.393 124.047 143.394C124.08 143.123 124.097 142.847 124.097 142.567C124.097 138.837 121.073 135.812 117.343 135.812C114.564 135.812 112.178 137.49 111.141 139.888C110.899 139.791 110.636 139.737 110.359 139.737C109.2 139.737 108.26 140.677 108.26 141.836C108.26 142.19 108.348 142.522 108.502 142.815C107.015 143.37 105.957 144.803 105.957 146.484C105.957 148.647 107.711 150.401 109.873 150.401H124.136C126.071 150.401 127.64 148.832 127.64 146.896C127.64 144.961 126.071 143.391 124.136 143.391Z",
    fill: "#008BF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.839 173.482L106.778 173.425C104.678 173.085 103.072 171.263 103.072 169.066V160.755L120.865 137.211C122.762 134.7 126.533 134.7 128.431 137.211L142.287 155.548L155.817 173.452L155.839 173.482Z",
    fill: "url(#paint11_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.072 142.032C131.288 142.861 129.875 142.76 129.24 141.732V141.727C128.887 141.159 128.299 140.876 127.708 140.876C127.117 140.876 126.529 141.159 126.177 141.73C125.824 142.298 125.236 142.584 124.645 142.584C124.054 142.584 123.466 142.298 123.114 141.73C122.761 141.161 122.173 140.876 121.582 140.876C120.991 140.876 120.403 141.161 120.05 141.73C119.418 142.757 118.01 142.859 117.223 142.033L120.865 137.212C122.761 134.7 126.534 134.7 128.431 137.212L132.072 142.032Z",
    fill: "url(#paint12_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.543 155.322C194.543 155.322 194.389 155.758 193.784 156.364C193.559 156.589 173.743 176.704 173.743 176.704C172.34 178.128 170.425 178.93 168.426 178.93C170.151 178.93 171.55 177.531 171.55 175.805V160.53C171.55 157.654 173.882 155.322 176.758 155.322H194.543Z",
    fill: "url(#paint13_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.369 129.448C161.339 129.448 161.31 129.449 161.28 129.45C161.313 129.179 161.331 128.903 161.331 128.624C161.331 124.893 158.306 121.869 154.576 121.869C151.798 121.869 149.411 123.547 148.374 125.944C148.133 125.847 147.869 125.794 147.593 125.794C146.433 125.794 145.493 126.733 145.493 127.893C145.493 128.246 145.581 128.579 145.735 128.871C144.249 129.427 143.19 130.86 143.19 132.54C143.19 134.703 144.944 136.457 147.107 136.457H161.369C163.305 136.457 164.874 134.888 164.874 132.953C164.874 131.017 163.305 129.448 161.369 129.448Z",
    fill: "#008BF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.259 132.66L176.449 121.85C174.517 119.82 171.79 118.553 168.766 118.553C162.906 118.553 158.156 123.303 158.156 129.162C158.156 132.187 159.424 134.913 161.454 136.846L187.259 162.651V132.66Z",
    fill: "url(#paint14_linear_1418_15090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.766 139.771C174.626 139.771 179.376 135.021 179.376 129.162C179.376 123.302 174.626 118.552 168.766 118.552C162.906 118.552 158.156 123.302 158.156 129.162C158.156 135.021 162.906 139.771 168.766 139.771Z",
    fill: "url(#paint15_linear_1418_15090)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1418_15090",
    x: 0,
    y: 0,
    width: 288,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.48125 0 0 0 0 0.574292 0 0 0 0 0.641667 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_15090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_15090",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1418_15090",
    x1: 143.979,
    y1: 141.103,
    x2: 146.34,
    y2: 24.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1418_15090",
    x1: 149.353,
    y1: 165.421,
    x2: 152.332,
    y2: 179.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363F3E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1418_15090",
    x1: 177.167,
    y1: 175.11,
    x2: 188.89,
    y2: 186.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1418_15090",
    x1: 145.167,
    y1: 105.024,
    x2: 145.167,
    y2: 180.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1418_15090",
    x1: 145.168,
    y1: 129.638,
    x2: 145.168,
    y2: 184.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1418_15090",
    x1: 145.167,
    y1: 173.012,
    x2: 145.167,
    y2: 179.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1418_15090",
    x1: 142.925,
    y1: 167.045,
    x2: 112.618,
    y2: 136.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1418_15090",
    x1: 153.867,
    y1: 136.508,
    x2: 153.867,
    y2: 175.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1418_15090",
    x1: 171.225,
    y1: 170.252,
    x2: 141.059,
    y2: 140.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1ACEB8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04959C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1418_15090",
    x1: 158.359,
    y1: 142.133,
    x2: 158.359,
    y2: 147.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1418_15090",
    x1: 157.866,
    y1: 147.142,
    x2: 152.135,
    y2: 141.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1418_15090",
    x1: 129.457,
    y1: 127.82,
    x2: 129.457,
    y2: 175.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1418_15090",
    x1: 124.649,
    y1: 135.429,
    x2: 124.649,
    y2: 141.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1418_15090",
    x1: 172.144,
    y1: 157.78,
    x2: 182.407,
    y2: 168.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1418_15090",
    x1: 190.76,
    y1: 151.15,
    x2: 154.425,
    y2: 114.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1418_15090",
    x1: 168.768,
    y1: 110.772,
    x2: 168.768,
    y2: 148.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FFC954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_15090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.474,
    height: 109.474,
    fill: "white",
    transform: "translate(89.2632 85.2627)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImgHover);
export default __webpack_public_path__ + "static/media/profileImgHover.89435eb80b9f61a666350af98a45f94b.svg";
export { ForwardRef as ReactComponent };